import { FoodsIcon } from "@foodpilot/foods";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    setOpen: (v: boolean) => void;
};
export const DeleteButton = (props: Props) => {
    const { setOpen } = props;
    const { t } = useTranslation();

    return (
        <Box>
            <Button
                variant="error"
                startIcon={<FoodsIcon icon="delete" size={2} />}
                onClick={() => {
                    setOpen(true);
                }}
            >
                {t("actionPlan.settings.delete_button", "Delete my action plan")}
            </Button>
        </Box>
    );
};
